export default "__VITE_ASSET__S_sI1iRg__"